import React, { createContext, useContext, useState } from "react";

const TabContext = createContext();

export const TabProvider = ({ children }) => {
  const [employeeTab, setEmployeeTab] = useState(1);
  const [personnelCategoriesTab, setPersonnelCategoriesTab] = useState(0);
  const [timeKeepingTab, setTimeKeepingTab] = useState(0);
  const [projectManagerTab, setProjectManagerTab] = useState(0);
  const [commissionInfoTab, setCommissionInfoTab] = useState(0);
  const [honorTab, setHonorTab] = useState(0);
  const [statementTab, setStatementTab] = useState(0);
  const [activityTab, setActivityTab] = useState(0);

  return (
    <TabContext.Provider
      value={{
        employeeTab,
        setEmployeeTab,
        personnelCategoriesTab,
        setPersonnelCategoriesTab,
        timeKeepingTab,
        setTimeKeepingTab,
        projectManagerTab,
        setProjectManagerTab,
        commissionInfoTab,
        setCommissionInfoTab,
        honorTab,
        setHonorTab,
        statementTab,
        setStatementTab,
        activityTab,
        setActivityTab
      }}
    >
      {children}
    </TabContext.Provider>
  );
};

export const useTab = () => useContext(TabContext);
